<template>
  <section>
    <el-container>
      <el-form label-width="120px" :model="UserForm" :rules="Rules" ref="User">
        <el-form-item label="手机号" prop="phoneNum">
          <el-input v-model="UserForm.phoneNum" placeholder="请输入手机号" length=11></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="UserForm.password" auto-complete="new-password"
                    placeholder="请输入新密码"></el-input>
        </el-form-item>

        <!--  按钮  -->
        <el-form-item>
          <el-button type="primary" @click="changePasswd()">修改密码</el-button>
        </el-form-item>
      </el-form>
    </el-container>
  </section>
</template>

<script>
import {Message} from "element-ui";

export default {
  name: "ForgetPasswd",
  data() {
    return {
      Rules: '',
      UserForm: {
        password: '',
        phoneNum: '',
      }
    }
  },
  methods: {
    // 修改密码
    changePasswd() {
      if (!this.UserForm.phoneNum) {
        Message.error("请输入邮箱！");
        return;
      } else if (this.UserForm.phoneNum != null) {
        const reg = /^1[3456789]\d{9}$/;
        if (!reg.test(this.UserForm.phoneNum)) {
          Message.error("请输入有效的手机号！");
        } else if (!this.UserForm.password) {
          Message.error("请输入密码！");
          return;
        } else {
          this.$http.post("/register", this.UserForm).then(res => {
            if (res.data.code == 1) {
              Message.success("注册成功，快去登陆吧")
            } else {
              Message.error(res.data.data)
            }
          });
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
